// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".circular_progress {\n    width: 100%;\n    height: 200px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.circular_progress.full_screen {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: #00000070;\n    z-index: 9;\n}\n\n.circular_progress > div {\n    color: #FFFFFF;\n}\n\ntable .circular_progress > div {\n    color: #3f51b5;\n}\n", ""]);
// Exports
module.exports = exports;
